import Vue from 'vue';
import Trend from 'vuetrend';

Vue.use(Trend);
